import { render, staticRenderFns } from "./OverlayBG.vue?vue&type=template&id=48867c6b&"
import script from "./OverlayBG.vue?vue&type=script&lang=js&"
export * from "./OverlayBG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports